import { cn } from '@/lib/utils'
import { forwardRef } from 'react'

const Skeleton = forwardRef<
    HTMLDivElement,
    React.HTMLAttributes<HTMLDivElement>
>(({ className, ...props }, ref) => {
    return (
        <div
            ref={ref}
            {...props}
            className={cn(
                'relative overflow-hidden bg-muted-foreground/20 rounded-md',
                'size-full flex flex-grow',
                className,
            )}
        >
            <div className="absolute inset-0 -translate-x-full bg-gradient-to-r from-transparent via-accent to-transparent animate-shimmer" />
        </div>
    )
})

Skeleton.displayName = 'Skeleton'

export default Skeleton
